<template>
  <div>
    <textarea class="form-control form-control-sm" rows="6" ref="editor" @blur="format" autocomplete="off"
              spellcheck="false" :placeholder="placeholder"></textarea>
    <span class="text-danger" v-text="error"></span>
  </div>
</template>

<script>
import {onMounted, ref, watch} from "vue";

export default {
  name: "JsonEditor",
  props: {
    modelValue: String,
    placeholder: String,
    autoFocus: {type: Boolean, default: false},
  },
  emits: ['update:modelValue'],
  setup(props, {emit}) {
    const editor = ref(null);
    const error = ref('');

    onMounted(() => {
      editor.value.value = props.modelValue || '';
      editor.value.focus();
    });

    watch(() => props.modelValue, (value) => {
      editor.value.value = value;
    });

    const format = () => {
      error.value = '';

      if (editor.value?.value) {
        try {
          let json = JSON.parse(editor.value.value);
          editor.value.value = JSON.stringify(json, null, 2);
        } catch (e) {
          error.value = e.message;
        }
      }

      emit('update:modelValue', editor.value?.value);
    }

    return {
      editor,
      format,
      error
    }
  }
}
</script>
